module.exports = __webpack_public_path__ + "static/media/friend.ac1cefa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/compliance/friend.png
// module id = 508
// module chunks = 0